export default __webpack_public_path__ + "static/media/blog1.6b36dfc5.jpg";